// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Uf-dv","textarea":"styles_textarea__14RBe"};